module.exports = __webpack_public_path__ + "img/image-012.45d66122.png";